export const LOCAL_DOMAIN = 'http://localhost:3000';
export const DEVELOPMENT_DOMAIN = 'https://mexico.development.app.rentax.es';
export const TAXDOWN_ASSETS_DOMAIN = 'https://assets.taxdown.es/assets';
export const PAYMENT_DOMAIN = 'https://buy.stripe.com/';
